import {
    clearKeyword,
    setKeyword,
} from '../reducers';

import {visibilityStateSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

export const useMessagesSearch = () => {

    const dispatch = useAppDispatch();

    // FNP-950: the keyword is genuine Redux UI state (visibility), never
    // came from the records slice, and is unaffected by its removal.
    const {keyword} = useAppSelector((state) => visibilityStateSelector(state));

    // FILTERING AND PAGING
    const handleFilterByKeyword = (keyword: string) => {
        if (keyword !== '') {
            dispatch(setKeyword(keyword));
        } else {
            dispatch(clearKeyword());
        }
    };


    return {
        keyword,
        handleFilterByKeyword,
    };
};
